const ACTIVE_THREAD_SELECTOR = ".js-message-thread-active";

function scrollActiveThreadIntoView(element) {
  const scrollContainer = element.closest(".inbox__sidebar .card-body");
  if (!(scrollContainer instanceof HTMLElement)) {
    return;
  }

  const itemRect = element.getBoundingClientRect();
  const containerRect = scrollContainer.getBoundingClientRect();
  const offset = itemRect.top - containerRect.top;

  if (offset >= 0 && itemRect.bottom <= containerRect.bottom) {
    return;
  }

  scrollContainer.scrollTo({
    top: scrollContainer.scrollTop + offset - (scrollContainer.clientHeight - itemRect.height) / 2,
    behavior: "auto",
  });
}

export function initMessageThreadSidebar(root = document) {
  if (!(root instanceof Document || root instanceof Element)) {
    return;
  }

  const activeThread = root.querySelector(ACTIVE_THREAD_SELECTOR);
  if (!(activeThread instanceof HTMLElement)) {
    return;
  }

  window.requestAnimationFrame(() => scrollActiveThreadIntoView(activeThread));
}

window.setTimeout(() => initMessageThreadSidebar(), 0);
window.addEventListener("load", () => initMessageThreadSidebar(), { once: true });
